import OptimizerEditDto from "./OptimizerEditDto";

export class PowellOptimizerEditDto extends OptimizerEditDto {
    constructor() {
        super();
        /** @type {number} */
        this.maxiter = null;
        /** @type {number} */
        this.xtol = null;
        /** @type {number} */
        this.ftol = null;
        /** @type {number} */
        this.tol = null;
    }

    /**
     * @typedef {Object} _PowellOptimizerEditDtoProps
     * @property {number} maxiter
     * @property {number} xtol
     * @property {number} ftol
     * @property {number} tol
     * 
     * @typedef {import('./OptimizerEditDto').OptimizerEditDtoProps & _PowellOptimizerEditDtoProps} PowellOptimizerEditDtoProps
     */
    /**
     * 
     * @param {PowellOptimizerEditDtoProps} props
     * @returns {PowellOptimizerEditDto}
     */
    setup(props) {
        super.setup(props);

        this.maxiter = props.maxiter;
        this.xtol = props.xtol;
        this.ftol = props.ftol;
        this.tol = props.tol;
        return this;
    }
}

export default PowellOptimizerEditDto;